<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        {{$t('restricted_people')}}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar por nombre"
          single-line
          hide-details
          @keyup.enter="fetchPeople"
        ></v-text-field>
        <v-btn color="primary" class="ml-4" @click="fetchPeople" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn color="success" class="ml-4" @click="openPersonDialog()">
          <v-icon left>mdi-plus</v-icon> Agregar Persona
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="people"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:item.isActive="{ item }">
          <v-chip :color="item.isActive ? 'red' : 'green'" dark small>
            {{ item.isActive ? 'Restringido' : 'Inactivo' }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="blue" @click="openPersonDialog(item)" title="Editar Persona">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <!-- <v-btn icon color="purple" @click="openRulesDialog(item)" title="Gestionar Reglas">
            <v-icon>mdi-shield-account</v-icon>
          </v-btn> -->
          <v-btn icon color="error" @click="deletePerson(item)" title="Eliminar Persona">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <!-- Dialog for Person -->
    <v-dialog v-model="personDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editingPerson ? 'Editar Persona' : 'Nueva Persona Restringida' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="personForm.fullName" label="Nombre Completo" required :error-messages="personFormErrors.fullName"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    counter="500"
                    maxlength="500"
                    :rules="[v => !v || v.length <= 500 || 'Máximo 500 caracteres']"
                    v-model="personForm.notes" label="Notas / Motivo general"
                    rows="3"></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-switch v-model="personForm.isActive" label="Restricción Activa" color="red"></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="personForm.startsAt" label="Fecha de Inicio" type="date" :error-messages="personFormErrors.startsAt"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="personForm.endsAt" label="Fecha de Fin (Opcional)" type="date"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  v-model="personForm.photo"
                  label="Foto de la Persona"
                  accept="image/*"
                  prepend-icon="mdi-camera"
                  show-size
                  clearable
                  :hint="editingPerson && editingPerson.photo ? 'Sube una nueva imagen para reemplazar la actual' : ''"
                  persistent-hint
                ></v-file-input>
              </v-col>
              <v-col cols="12" v-if="editingPerson && editingPerson.photo && !personForm.photo">
                <div class="text-caption grey--text mb-1">Foto actual:</div>
                <v-img
                  :src="editingPerson.photo"
                  max-height="150"
                  max-width="150"
                  contain
                  class="rounded elevation-1 photo-thumbnail"
                  @click="openPhotoZoom()"
                  title="Clic para ampliar"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="personDialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="savePerson" :loading="savingPerson">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for Rules -->
    <v-dialog v-model="rulesDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Reglas de Restricción: {{ selectedPerson ? selectedPerson.fullName : '' }}</span>
        </v-card-title>
        <v-card-text>
          <v-btn color="primary" small class="mb-4" @click="showRuleForm = !showRuleForm">
            <v-icon left>mdi-plus</v-icon> Agregar Nueva Regla
          </v-btn>
          <v-expand-transition>
            <div v-if="showRuleForm" class="mb-4 p-3 elevation-1" style="padding: 15px; border-radius: 4px; border: 1px solid #e0e0e0; background-color: #f9f9f9;">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-switch
                    v-model="ruleForm.isGlobal"
                    :label="ruleForm.isGlobal ? 'Global (Todo el residencial)' : 'Solo mi fraccionamiento/unidad'"
                    color="red">
                  </v-switch>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-switch v-model="ruleForm.isActive" label="Regla Activa" color="primary"></v-switch>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="ruleForm.reason"
                    label="Motivo de la regla (Opcional)"
                    counter="500"
                    maxlength="500"
                    :rules="[v => !v || v.length <= 500 || 'Máximo 500 caracteres']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="ruleForm.startsAt" label="Fecha de Inicio" type="date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="ruleForm.endsAt" label="Fecha de Fin (Opcional)" type="date"></v-text-field>
                </v-col>
              </v-row>
              <v-btn color="success" class="mr-2" small @click="saveRule" :loading="savingRule">Guardar Regla</v-btn>
              <v-btn text small @click="showRuleForm = false">Cancelar</v-btn>
            </div>
          </v-expand-transition>
          <v-data-table
            :headers="ruleHeaders"
            :items="rules"
            :loading="loadingRules"
            class="elevation-1"
            hide-default-footer
          >
            <template v-slot:item.idHousingUnit="{ item }">
              <v-chip :color="item.idHousingUnit ? 'primary' : 'red'" dark small>
                {{ item.idHousingUnit ? 'Unidad Específica' : 'Global' }}
              </v-chip>
            </template>
            <template v-slot:item.isActive="{ item }">
              <v-icon :color="item.isActive ? 'green' : 'grey'">mdi-check-circle</v-icon>
            </template>
            <template v-slot:item.startsAt="{ item }">
              {{ formatDateDisplay(item.startsAt) }}
            </template>
            <template v-slot:item.endsAt="{ item }">
              {{ item.endsAt ? formatDateDisplay(item.endsAt) : 'Indefinido' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon color="error" small @click="deleteRule(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="rulesDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Zoom de foto -->
    <v-dialog v-model="photoZoomDialog" max-width="600px">
      <v-card class="pa-2" color="grey darken-4">
        <v-card-actions class="pa-1">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="photoZoomDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text class="pa-2">
          <v-img
            v-if="zoomPhotoUrl"
            :src="zoomPhotoUrl"
            contain
            max-height="550"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'RestrictedPeople',
  data () {
    return {
      search: '',
      loading: false,
      people: [],
      headers: [
        { text: 'Nombre', value: 'fullName' },
        { text: 'Estado', value: 'isActive' },
        { text: 'Notas', value: 'notes' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      // Person Dialog
      personDialog: false,
      photoZoomDialog: false,
      zoomPhotoUrl: '',
      editingPerson: null,
      editingRuleId: null,
      savingPerson: false,
      personForm: {
        fullName: '',
        notes: '',
        isActive: true,
        startsAt: '',
        endsAt: '',
        photo: null
      },
      personFormErrors: {
        fullName: '',
        startsAt: ''
      },
      // Rules Dialog
      rulesDialog: false,
      selectedPerson: null,
      rules: [],
      loadingRules: false,
      ruleHeaders: [
        { text: 'Alcance', value: 'idHousingUnit' },
        { text: 'Motivo', value: 'reason' },
        { text: 'Inicio', value: 'startsAt' },
        { text: 'Fin', value: 'endsAt' },
        { text: 'Activa', value: 'isActive' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      showRuleForm: false,
      savingRule: false,
      ruleForm: {
        isGlobal: true,
        reason: '',
        startsAt: '',
        endsAt: '',
        isActive: true
      },
      baseUrl: 'https://residencial-services.intrare.app'
    }
  },
  computed: {
    ...mapGetters(['getProfile', 'getToken']),
    axiosConfig () {
      return {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + this.getToken
        }
      }
    }
  },
  watch: {
    // Si el perfil tardó en cargar, este watcher detectará el cambio y lo ejecutará
    'getProfile.idHousingUnit': {
      handler (newVal) {
        if (newVal) {
          this.fetchPeople()
        }
      },
      immediate: true
    }
  },
  methods: {
    formatDatePayload (dateStr) {
      if (!dateStr) return null
      return dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00-06:00'
    },
    formatDateDisplay (dateStr) {
      if (!dateStr) return ''
      return dateStr.split('T')[0]
    },
    async fetchPeople () {
      this.loading = true
      try {
        let url = `${this.baseUrl}/people/?housing_unit=${this.getProfile.idHousingUnit}`
        if (this.search) {
          url += `&search=${this.search}`
        }
        const response = await axios.get(url, this.axiosConfig)
        this.people = response.data
      } catch (error) {
        this.showError('Error al cargar personas restringidas')
      } finally {
        this.loading = false
      }
    },
    async openPersonDialog (person = null) {
      this.editingPerson = person
      this.photoZoomDialog = false
      this.zoomPhotoUrl = ''
      this.personForm = { fullName: '', notes: '', isActive: true, startsAt: '', endsAt: '', photo: null }
      this.personFormErrors = { fullName: '', startsAt: '' }
      if (person) {
        this.personForm = { ...person, startsAt: '', endsAt: '', photo: null }
        this.personDialog = true
        try {
          const response = await axios.get(`${this.baseUrl}/rules/?person=${person.id}`, this.axiosConfig)
          const rules = response.data
          const myRule = rules.find(r => r.idHousingUnit === this.getProfile.idHousingUnit)
          if (myRule) {
            this.editingRuleId = myRule.id
            this.personForm.startsAt = myRule.startsAt ? myRule.startsAt.split('T')[0] : ''
            this.personForm.endsAt = myRule.endsAt ? myRule.endsAt.split('T')[0] : ''
          } else {
            this.editingRuleId = null
          }
        } catch (e) {
          console.error('Error fetching rule for person', e)
        }
      } else {
        const today = new Date().toISOString().split('T')[0]
        this.personForm = { fullName: '', notes: '', isActive: true, startsAt: today, endsAt: '', photo: null }
        this.personDialog = true
      }
    },
    async savePerson () {
      this.personFormErrors = { fullName: '', startsAt: '' }
      if (!this.personForm.fullName) {
        this.personFormErrors.fullName = 'El nombre es requerido'
        return
      }
      if (!this.editingPerson && !this.personForm.startsAt) {
        this.personFormErrors.startsAt = 'La fecha de inicio es requerida'
        return
      }
      this.savingPerson = true
      try {
        if (this.editingPerson) {
          let personConfig = this.axiosConfig
          let payload
          if (this.personForm.photo instanceof File) {
            payload = new FormData()
            payload.append('fullName', this.personForm.fullName)
            payload.append('notes', this.personForm.notes || '')
            payload.append('isActive', this.personForm.isActive)
            payload.append('photo', this.renameWithUUID(this.personForm.photo))
            personConfig = { headers: { 'authorization': 'Token ' + this.getToken } }
          } else {
            payload = {
              fullName: this.personForm.fullName,
              notes: this.personForm.notes,
              isActive: this.personForm.isActive
            }
          }
          await axios.patch(`${this.baseUrl}/people/${this.editingPerson.id}/`, payload, personConfig)
          if (this.editingRuleId) {
            const rulePayload = {
              startsAt: this.formatDatePayload(this.personForm.startsAt),
              endsAt: this.personForm.endsAt ? this.formatDatePayload(this.personForm.endsAt) : null,
              reason: this.personForm.notes,
              isActive: this.personForm.isActive
            }
            await axios.patch(`${this.baseUrl}/rules/${this.editingRuleId}/`, rulePayload, this.axiosConfig)
          } else if (this.personForm.startsAt) {
            const rulePayload = {
              idRestrictedPerson: this.editingPerson.id,
              idHousingUnit: this.getProfile.idHousingUnit,
              reason: this.personForm.notes,
              startsAt: this.formatDatePayload(this.personForm.startsAt),
              isActive: this.personForm.isActive
            }
            if (this.personForm.endsAt) {
              rulePayload.endsAt = this.formatDatePayload(this.personForm.endsAt)
            } else {
              rulePayload.endsAt = null
            }
            await axios.post(`${this.baseUrl}/rules/`, rulePayload, this.axiosConfig)
          }

          this.showSuccess('Persona actualizada correctamente')
        } else {
          let personConfig = this.axiosConfig
          let personPayload
          if (this.personForm.photo instanceof File) {
            personPayload = new FormData()
            personPayload.append('fullName', this.personForm.fullName)
            personPayload.append('notes', this.personForm.notes || '')
            personPayload.append('isActive', this.personForm.isActive)
            personPayload.append('photo', this.renameWithUUID(this.personForm.photo))
            personConfig = { headers: { 'authorization': 'Token ' + this.getToken } }
          } else {
            personPayload = {
              fullName: this.personForm.fullName,
              notes: this.personForm.notes,
              isActive: this.personForm.isActive
            }
          }
          const personResponse = await axios.post(`${this.baseUrl}/people/`, personPayload, personConfig)
          const newPersonId = personResponse.data.id
          const rulePayload = {
            idRestrictedPerson: newPersonId,
            idHousingUnit: this.getProfile.idHousingUnit,
            reason: this.personForm.notes,
            startsAt: this.formatDatePayload(this.personForm.startsAt),
            isActive: true
          }
          if (this.personForm.endsAt) {
            rulePayload.endsAt = this.formatDatePayload(this.personForm.endsAt)
          } else {
            rulePayload.endsAt = null
          }
          await axios.post(`${this.baseUrl}/rules/`, rulePayload, this.axiosConfig)

          this.showSuccess('Persona y regla creadas exitosamente')
        }
        this.personDialog = false
        this.fetchPeople()
      } catch (error) {
        if (error.response && error.response.data && error.response.data.fullName) {
          this.personFormErrors.fullName = error.response.data.fullName
        } else {
          this.showError('Error al guardar los datos de la persona')
        }
      } finally {
        this.savingPerson = false
      }
    },
    async deletePerson (person) {
      if (confirm(`¿Estás seguro de eliminar a ${person.fullName}? Esto no se puede deshacer.`)) {
        try {
          await axios.delete(`${this.baseUrl}/people/${person.id}/`, this.axiosConfig)
          this.showSuccess('Persona eliminada')
          this.fetchPeople()
        } catch (error) {
          this.showError('Error al eliminar a la persona')
        }
      }
    },
    // Rules Methods
    async openRulesDialog (person) {
      this.selectedPerson = person
      this.rulesDialog = true
      this.showRuleForm = false
      const today = new Date().toISOString().split('T')[0]
      this.ruleForm = {
        isGlobal: true,
        reason: '',
        startsAt: today,
        endsAt: '',
        isActive: true
      }
      this.fetchRules()
    },
    async fetchRules () {
      this.loadingRules = true
      try {
        const response = await axios.get(`${this.baseUrl}/rules/?person=${this.selectedPerson.id}`, this.axiosConfig)
        this.rules = response.data
      } catch (error) {
        this.showError('Error al cargar reglas')
      } finally {
        this.loadingRules = false
      }
    },
    async saveRule () {
      if (!this.ruleForm.startsAt) {
        this.showError('La fecha de inicio es requerida')
        return
      }
      this.savingRule = true
      const payload = {
        idRestrictedPerson: this.selectedPerson.id,
        idHousingUnit: this.ruleForm.isGlobal ? null : this.getProfile.idHousingUnit,
        reason: this.ruleForm.reason,
        startsAt: this.formatDatePayload(this.ruleForm.startsAt),
        isActive: this.ruleForm.isActive
      }
      if (this.ruleForm.endsAt) {
        payload.endsAt = this.formatDatePayload(this.ruleForm.endsAt)
      } else {
        payload.endsAt = null
      }
      try {
        await axios.post(`${this.baseUrl}/rules/`, payload, this.axiosConfig)
        this.showSuccess('Regla agregada correctamente')
        this.showRuleForm = false
        this.fetchRules()
      } catch (error) {
        this.showError('Error al guardar la regla')
      } finally {
        this.savingRule = false
      }
    },
    async deleteRule (rule) {
      if (confirm('¿Estás seguro de eliminar esta regla?')) {
        try {
          await axios.delete(`${this.baseUrl}/rules/${rule.id}/`, this.axiosConfig)
          this.showSuccess('Regla eliminada')
          this.fetchRules()
        } catch (error) {
          this.showError('Error al eliminar regla')
        }
      }
    },
    // Helpers
    openPhotoZoom () {
      this.zoomPhotoUrl = this.editingPerson && this.editingPerson.photo ? this.editingPerson.photo : ''
      if (this.zoomPhotoUrl) {
        this.photoZoomDialog = true
      }
    },
    renameWithUUID (file) {
      const uuid = crypto.randomUUID()
      const ext = file.name.includes('.') ? file.name.substring(file.name.lastIndexOf('.')) : ''
      const newName = `${uuid}${ext}`
      return new File([file], newName, { type: file.type, lastModified: file.lastModified })
    },
    showError (msg) {
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', msg)
    },
    showSuccess (msg) {
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', msg)
    }
  }
}
</script>

<style scoped>
.v-data-table {
  margin-top: 10px;
}
.photo-thumbnail {
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.photo-thumbnail:hover {
  opacity: 0.8;
}
</style>
